<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-print' class='navbarbtn' v-if='showPrintPower'
        @click='print'>
        打 印
      </el-button>

      <el-button type='primary' icon='wms wms-devdate' class='navbarbtn' v-if='showPlanPower'
        @click='showPlanICMOEntryDialogMD'>
        排 程
      </el-button>

      <el-button type='danger' icon='wms wms-devdate' class='navbarbtn' v-if='showCancelPlanPower'
        @click='cancelPlanICMOEntry'>
        反排程
      </el-button>

      <el-button type='primary' icon='sys sys-yes4' class='navbarbtn' v-if='showReleasePower'
        @click='releaseICMOEntry'>
        下 达
      </el-button>

      <el-button type='danger' icon='sys sys-yes4' class='navbarbtn' v-if='showCancelReleasePower'
        @click='cancelReleaseICMOEntry'>
        反下达
      </el-button>

       <!-- <el-button type='primary' icon='wms wms-split' class='navbarbtn' v-if='showSplitPower'
        @click='showSplitICMOEntryDialogMD'>
        拆 分
      </el-button>

      <el-button type='primary' icon='wms wms-merge' class='navbarbtn' v-if='showMergePower'
        @click='mergeICMOEntry'>
        合 并
      </el-button> -->

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :reduceHeight='200'
      :expandRowKeys='mainTable.expandRowKeys'
      :showOperationsColumn='true' operationColumnWidth='60'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='已上材料查询' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showICMOEntryFeedDialogMD(scope)'><i class='wms wms-search1'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>记录号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>操作时间</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>操作账号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 120px; text-align: left;'><span style='color: #42426F;'>操作类型</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 150px; text-align: left;'><span style='color: #42426F;'>设备</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>职员</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>备注</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(icmoer, index) in scope.data.row.detailDt1'
            :key='icmoer.RecordID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'>
              <span :style='"color: blue;"'>{{index + 1}} </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.RecordID}} </span>
            </div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'>
              <span :style='"color: blue;"'>
                {{!icmoer.ReportTime ? '' : dateTimeUtil.formartDateTime(new Date(icmoer.ReportTime), 'yyyy-MM-dd HH:mm:ss')}}
              </span>
            </div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.ReportUserName}} </span>
            </div>
            <div class='expand-row' style='min-width: 120px; text-align: left;'>
              <span :style='"color: blue;"'>{{showExpandTransformSpecialString('ReportType', icmoer.ReportType)}} </span>
            </div>
            <div class='expand-row' style='min-width: 150px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.ReportMachineName ? icmoer.ReportMachineName + '(' + icmoer.ReportMachineNumber + ')' : ''}} </span>
            </div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'>
              <span :style='"color: blue;"'>{{(icmoer.ReportEmployeeName ? icmoer.ReportEmployeeName : '') +
                (icmoer.ReportEmployeeName2 ? '|' + icmoer.ReportEmployeeName2 : '') +
                (icmoer.ReportEmployeeName3 ? '|' + icmoer.ReportEmployeeName3 : '') +
                (icmoer.ReportEmployeeName4 ? '|' + icmoer.ReportEmployeeName4 : '') +
                (icmoer.ReportEmployeeName5 ? '|' + icmoer.ReportEmployeeName5 : '') +
                (icmoer.ReportEmployeeName6 ? '|' + icmoer.ReportEmployeeName6 : '') }}
              </span>
            </div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'>
              <span :style='"color: blue;"'>{{icmoer.Remark}} </span>
            </div>
          </div>
        </div>
      </template>
    </Table>

    <!-- 排程弹出框 -->
    <el-dialog v-dialogDrag :title='"工单排程"' :visible.sync='showPlanICMOEntryDialog'
      width='620px' top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划开始
          </div>
          <el-date-picker v-model='planICMOEntry.PlanStartTime' class='inputField-input' value-format='yyyy-MM-dd'
            size='mini' style='width: 200px;'>
          </el-date-picker>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划结束
          </div>
          <el-date-picker v-model='planICMOEntry.PlanEndTime' class='inputField-input' value-format='yyyy-MM-dd'
            size='mini' style='width: 200px;'>
          </el-date-picker>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备1
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员1
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备2
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID2' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员2
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID2' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备3
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID3' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员3
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID3' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备4
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID4' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员4
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID4' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备5
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID5' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员5
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID5' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div style='margin-top: 10px; height: 30px;'>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划设备6
          </div>
          <el-select v-model='planICMOEntry.PlanMachineID6' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='machine in machines'
              :key='machine.ID' :label='machine.Name + "(" + machine.Number + ")"' :value='machine.ID'>
            </el-option>
          </el-select>
          <div class='inputField-label' style='width: 70px; text-align: left'>
            计划职员6
          </div>
          <el-select v-model='planICMOEntry.PlanEmployeeID6' placeholder='请选择'
            class='inputField-input'
            style='width: 200px;' size='mini'>
            <el-option v-for='employee in employees'
              :key='employee.EmployeeID' :label='employee.Name + "(" + employee.Number + ")"' :value='employee.EmployeeID'>
            </el-option>
          </el-select>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
          <el-button type='primary' @click='planICMOEntryMD()' size='mini'>排程</el-button>
          <el-button @click='showPlanICMOEntryDialog = false' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title='已上物料明细' :visible.sync='showICMOEntryFeedDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='icmoEntryFeeds' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;' default-expand-all>
        <el-table-column type='expand' width='50'>
          <template #default='scope'>
            <div class='expand'>
              <div class='expand-inner'>
                <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
                <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
              </div>
            </div>
            <div class='expand'>
              <div v-for='(qrCode, qrCodeIndex) in scope.row.detailDt1'
                :key='qrCode.QRCode' class='expand-inner'>
                <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'></span>{{qrCodeIndex + 1}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.QRCode}} </div>
                <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'></span>{{qrCode.Qty}}{{qrCode.BU_Name}} </div>
                <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.OuterQRCode}} </div>
                <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'></span>{{qrCode.SupplyBatchNo}} </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop='EntryID' label='行号' width='60'>
        </el-table-column>
        <el-table-column prop='ItemNumber' label='物料代码' width='300'>
        </el-table-column>
        <el-table-column prop='ItemName' label='物料名称' width='300'>
        </el-table-column>
        <el-table-column prop='ItemModel' label='规格型号' width='250'>
        </el-table-column>
        <el-table-column prop='Qty' label='数量' width='80'>
        </el-table-column>
        <el-table-column prop='UnitName' label='单位' width='80'>
        </el-table-column>
        <el-table-column prop='BatchNo' label='批号' width='100'>
        </el-table-column>
        <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
        </el-table-column>
        <el-table-column prop='KFPeriod' label='保质期' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import code from '@/components/sys/Code'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'
import { Loading } from 'element-ui'

export default {
  name: 'ICMOERelease',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PM_ICMOEntry',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,
      reportTypes: [],

      showPlanICMOEntryDialog: false,
      planICMOEntry: {
        PlanMachineID: '',
        PlanEmployeeID: '',
        PlanMachineID2: '',
        PlanEmployeeID2: '',
        PlanMachineID3: '',
        PlanEmployeeID3: '',
        PlanMachineID4: '',
        PlanEmployeeID4: '',
        PlanMachineID5: '',
        PlanEmployeeID5: '',
        PlanMachineID6: '',
        PlanEmployeeID6: '',
        PlanStartTime: '',
        PlanEndTime: ''
      },
      statuss: [],
      machines: [],
      employees: [],
      yesornos: [],

      showICMOEntryFeedDialog: false,
      showICMOEntryFeedsRow: {},
      icmoEntryFeeds: [],

      showCancelPlanPower: false,
      showCancelReleasePower: false,
      showDeletePower: false,
      showEditPower: false,
      showPlanPower: false,
      showReleasePower: false,
      showSplitPower: false,
      showMergePower: false,
      showPrintPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)
    const codes = that.codes
    that.statuss = code.getCode(codes, 'PM_ICMOEntry_Status')
    that.yesornos = code.getCode(codes, 'SYS_YesOrNo')
    that.reportTypes = code.getCode(codes, 'PM_ICMOEntryRecord_ReportType')

    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    const employeesPromise = table.getTableContent('BD_Employee', 10000, 1, '', " AND Deleted='0'")
    const machinesPromise = table.getTableContent('BD_Machine', 10000, 1, '', " AND Deleted='0'")

    await tableContentPromise
    await tableFilterInfoPromise
    const employeesObj = await employeesPromise
    const machinesObj = await machinesPromise

    that.employees = employeesObj.tableContent
    that.machines = machinesObj.tableContent
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Status === '1') {
        return { 'background-color': 'orange' }
      } else if (data.row.Status === '2') { // 淡蓝色
        return { 'background-color': '#CAE1FF' }
      } else if (data.row.Status === '3') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '4') { // 淡绿色
        return { 'background-color': '#C1FFC1' }
      } else if (data.row.Status === '5') { // 红色
        return { 'background-color': '#FF6A6A' }
      } else if (data.row.Status === '6') { // 淡灰色
        return { 'background-color': '#AAAAAA' }
      } else if (data.row.Status === '8') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else if (data.row.Status === '9') { // 灰色
        return { 'background-color': '#CCCCCC' }
      } else {
        return {}
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 排程弹出框显示方法
    showPlanICMOEntryDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择工单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '0' && that.mainTable.selections[i].Status !== '1') {
          that.$message.error('请选择未排程或者已排程的工单！')
          return
        }
      }
      that.planICMOEntry.PlanMachineID = ''
      that.planICMOEntry.PlanEmployeeID = ''
      that.planICMOEntry.PlanMachineID2 = ''
      that.planICMOEntry.PlanEmployeeID2 = ''
      that.planICMOEntry.PlanMachineID3 = ''
      that.planICMOEntry.PlanEmployeeID3 = ''
      that.planICMOEntry.PlanMachineID4 = ''
      that.planICMOEntry.PlanEmployeeID4 = ''
      that.planICMOEntry.PlanMachineID5 = ''
      that.planICMOEntry.PlanEmployeeID5 = ''
      that.planICMOEntry.PlanMachineID6 = ''
      that.planICMOEntry.PlanEmployeeID6 = ''
      that.planICMOEntry.PlanStartTime = ''
      that.planICMOEntry.PlanEndTime = ''
      that.showPlanICMOEntryDialog = true
    },

    // 工单排程
    planICMOEntryMD: async function () {
      const that = this
      if (that.planICMOEntry.PlanStartTime && that.planICMOEntry.PlanEndTime && that.planICMOEntry.PlanEndTime < that.planICMOEntry.PlanStartTime) {
        that.$message.error('计划开始时间不得大于计划结束时间！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.PlanICMOEntry', {
        rows: that.mainTable.selections,
        icmoEntry: that.planICMOEntry
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        if (rtnObj.msg) {
          that.$message.warning('排程成功，但是有异常信息！【' + rtnObj.msg + '】')
        } else {
          that.$message.success('排程成功！')
        }
        that.showPlanICMOEntryDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 工单反排程
    cancelPlanICMOEntry: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择工单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '1') {
          that.$message.error('请选择已排程的工单！')
          return
        }
      }
      that.$confirm('确定要反排程这些工单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelPlanICMOEntry', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('反排程成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 工单下达
    releaseICMOEntry: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择工单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '0' && that.mainTable.selections[i].Status !== '1') {
          that.$message.error('请选择未排程或者已排程的工单！')
          return
        }
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.ReleaseICMOEntry', {
        rows: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('下达成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 工单反排程
    cancelReleaseICMOEntry: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请先选择工单')
        return
      }
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (that.mainTable.selections[i].Status !== '2') {
          that.$message.error('请选择已下达的工单！')
          return
        }
      }
      that.$confirm('确定要反下达这些工单吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/ProduceManage.ICMOEntry.CancelReleaseICMOEntry', {
          rows: that.mainTable.selections
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.$message.success('反下达成功！')
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    },

    // 显示操作明细特征字符串转换方法
    showExpandTransformSpecialString: function (columnCode, val) {
      const that = this
      if (columnCode === 'ReportType') {
        return table.specialStringDisplayTransform(val, that.reportTypes)
      } else {
        return val
      }
    },

    // 打印
    print: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const rows = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        rows.push(that.mainTable.selections[i].DetailNo)
      }
      const dataJson = JSON.stringify(rows)
      window.open('/WebPrint/Print.Print.GetICMOEntryDataSet?DetailNos=' + dataJson + '&reportName=PMICMOEntry.rpt')
    },

    // 已上材料查询弹出框显示方法
    showICMOEntryFeedDialogMD: async function (scope) {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const icmoEntryFeedsObj = await table.getTableContent('PM_ICMOEntryFeed'
        , 10000, 1, ' ItemNumber ASC', " AND DetailNo='" + scope.data.row.DetailNo + "'")
      if (icmoEntryFeedsObj.error === '000000') {
        that.icmoEntryFeeds = icmoEntryFeedsObj.tableContent
        that.showICMOEntryFeedsRow = scope.data.row
        that.showICMOEntryFeedDialog = true
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
</style>
